module.exports = __webpack_public_path__ + "img/operationwise_logo.cb46df61.png";